import "./link.scss";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

const Link = ({ to, children, style, onClick, state = {} }) => {
  const navigate = useNavigate();
  return (
    <Button
      link
      type="button"
      className="edexlms-link"
      label={children}
      onClick={() => (onClick && onClick()) || navigate(to, { state })}
      style={style}
    />
  );
};

Link.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  onClick: PropTypes.func,
  state: PropTypes.object,
};

export default Link;
